import React, { useEffect, useRef, useState } from 'react';
import Shared from '../../Components/Frame/Shared';
import * as rsuite from 'rsuite';
import { Table } from 'rsuite';
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import axios from 'axios';
import { HiOutlineDocumentReport } from "react-icons/hi";
import DatePicker from "react-datepicker2";
import moment from 'moment-jalaali';
import { useNavigate } from 'react-router-dom';
import ResponsiveList, { CardTitle, CardField } from '../../Components/Shared/ResponsiveList';
import TicketMsgProp from '../../Components/Ticket/TicketMsgProp';
import TaskDetail from '../../Components/Task/TaskDetail';
import { isMobile } from 'react-device-detect';
import RowHeight from '../../Components/Shared/RowHeight';

const { Column, HeaderCell, Cell } = Table;

// گزارش کار انجام شده در یک بازه.
//
// از تاریخچه خوانده می شود، پس هر سطر یک کار واقعی است که آن روز انجام
// شده - نه فقط کارهایی که کامل تمام شده اند.
const Activity = () => {

    //#region Const

    let navigate = useNavigate();
    const TicketRef = useRef();
    const TaskRef = useRef();
    const [showTaskDrawer, setShowTaskDrawer] = useState(false);

    //--> پیش فرض: از ابتدای همین ماه تا امروز
    const [BeginDate, setBeginDate] = useState(moment().startOf('jMonth'));
    const [EndDate, setEndDate] = useState(moment());
    const [UserIds, setUserIds] = useState([]);
    const [UserList, setUserList] = useState([]);
    const [Data, setData] = useState(null);
    const [ShowLoading, setShowLoading] = useState(false);
    const [ActiveTab, setActiveTab] = useState('tickets');
    //#endregion

    //#region Methods

    const BindUsers = () => {
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/User/GetAll",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setUserList(res.data.map(item => ({
                    label: item.firstName + ' ' + item.lastName,
                    value: item.id
                })));
            })
            .catch(() => { })
    }

    const Bind = () => {
        if (!BeginDate || !EndDate) {
            General.ShowMsg(Enum.MsgType.error, "بازه زمانی را مشخص نمایید");
            return;
        }
        setShowLoading(true);
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/Report/Activity?userIds=" + UserIds.join(','),
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
                "beginDate": BeginDate.format('jYYYY/jMM/jDD'),
                "endDate": EndDate.format('jYYYY/jMM/jDD')
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setShowLoading(false);
                //--> سرویس در حالت خطا پاکت استاندارد بر می گرداند، نه گزارش
                if (res.data.isSuccess === false) {
                    General.ShowMsg(Enum.MsgType.error, res.data.error);
                    return;
                }
                setData(res.data);
            })
            .catch(error => {
                setShowLoading(false);
                if (error.response) {
                    if (error.response.status === 401) {
                        navigate("/UnAuthorize");
                    }
                    else if (error.response.status === 403) {
                        navigate("/AccessDenied");
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, "خطای " + error.response.status + " در دریافت گزارش");
                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                }
            })
    }

    // روی هر سطر تیکت، همان پنجره گفتگویی باز می شود که در صفحه تیکت ها هست.
    // کامپوننت مشترک است، پس جزئیات و پیوست ها همان شکل همیشگی را دارند.
    const ShowTicket = (rowData) => {
        if (rowData.number) {
            TicketRef.current.Show(rowData.itemId, rowData.number);
        }
    }

    // روی سطر وظیفه، همان فرم وظیفه باز می شود - با تاریخچه کامل وضعیت ها
    const ShowTask = (rowData) => {
        setShowTaskDrawer(true);
        setTimeout(() => {
            TaskRef.current.Show(rowData.itemId);
        }, 500);
    }

    //--> هر تب سطرش را به جای خودش می برد
    const OpenRow = (rowData) => {
        if (ActiveTab === 'tasks') {
            ShowTask(rowData);
        }
        else {
            ShowTicket(rowData);
        }
    }

    useEffect(() => {
        BindUsers();
    }, [])
    //#endregion

    const tickets = Data && Data.tickets ? Data.tickets : [];
    const tasks = Data && Data.tasks ? Data.tasks : [];
    const rows = ActiveTab === 'tickets' ? tickets : tasks;
    const isTaskTab = ActiveTab === 'tasks';

    return (
        <Shared pageTitle={<><HiOutlineDocumentReport size={25} /> گزارش کار روزانه</>}>

            <rsuite.Row>
                <rsuite.Col xs={24} md={5} className='mb-2'>
                    <label>از تاریخ</label>
                    <div onClick={(e) => e.preventDefault()}>
                        <DatePicker className="form-control" isGregorian={false} timePicker={false}
                            value={BeginDate} inputJalaaliFormat='jYYYY/jMM/jDD'
                            onChange={(value) => setBeginDate(value)} />
                    </div>
                </rsuite.Col>
                <rsuite.Col xs={24} md={5} className='mb-2'>
                    <label>تا تاریخ</label>
                    <div onClick={(e) => e.preventDefault()}>
                        <DatePicker className="form-control" isGregorian={false} timePicker={false}
                            value={EndDate} inputJalaaliFormat='jYYYY/jMM/jDD'
                            onChange={(value) => setEndDate(value)} />
                    </div>
                </rsuite.Col>
                <rsuite.Col xs={24} md={10} className='mb-2'>
                    <label>کارشناس</label>
                    <rsuite.TagPicker
                        data={UserList}
                        value={UserIds}
                        onChange={value => setUserIds(value ? value : [])}
                        className="w-100"
                        placeholder="همه کارشناسان"
                    />
                </rsuite.Col>
                <rsuite.Col xs={24} md={4} className='mb-2'>
                    <label>&nbsp;</label>
                    <div>
                        {
                            !ShowLoading ?
                                <rsuite.Button appearance="primary" className='w-100' onClick={Bind}>
                                    نمایش گزارش
                                </rsuite.Button>
                                :
                                <rsuite.Button appearance="primary" className='w-100' disabled>
                                    <rsuite.Loader />
                                </rsuite.Button>
                        }
                    </div>
                </rsuite.Col>
            </rsuite.Row>

            <rsuite.Divider />

            {
                Data === null ?
                    <div style={{ padding: 24, textAlign: 'center', color: '#8c97a3' }}>
                        بازه زمانی را انتخاب کنید و «نمایش گزارش» را بزنید
                    </div>
                    :
                    <>
                        <rsuite.Nav appearance="tabs" activeKey={ActiveTab} onSelect={setActiveTab}>
                            <rsuite.Nav.Item eventKey="tickets">
                                تیکت ها ({tickets.length})
                            </rsuite.Nav.Item>
                            <rsuite.Nav.Item eventKey="tasks">
                                وظایف ({tasks.length})
                            </rsuite.Nav.Item>
                        </rsuite.Nav>

                        <div className='mt-2'>
                            <ResponsiveList
                fillHeight
                                data={rows}
                                emptyText="در این بازه کاری ثبت نشده است"
                                filters={[
                                    { key: 'fullName', label: 'کارشناس', type: 'text' },
                                    { key: 'title', label: 'عنوان', type: 'text' },
                                    { key: 'ownerTitle', label: 'مربوط به', type: 'text' },
                                    { key: 'stateComment', label: 'اقدام', type: 'select' }
                                ]}
                                renderCard={(rowData) => (
                                    <>
                                        <CardTitle>
                                            <span className='HandCursor' style={{ color: '#2a78d6' }}
                                                onClick={() => OpenRow(rowData)}>
                                                {rowData.title}
                                            </span>
                                        </CardTitle>
                                        <CardField label="کارشناس">{rowData.fullName}</CardField>
                                        <CardField label="تاریخ">{rowData.date} - {rowData.time}</CardField>
                                        {
                                            rowData.number ?
                                                <CardField label="شماره">{rowData.number}</CardField>
                                                :
                                                null
                                        }
                                        <CardField label="مربوط به">{rowData.ownerTitle}</CardField>
                                        <CardField label="اقدام">{rowData.stateComment}</CardField>
                                        {
                                            rowData.comment ?
                                                <CardField label="توضیح">{rowData.comment}</CardField>
                                                :
                                                null
                                        }
                                    </>
                                )}
                            >
                                <Table
                                    rtl={true}
                                    className='w-100'
                                    bordered
                                    headerHeight={40}
                                    rowHeight={RowHeight}
                    wordWrap="break-word"
                                    data={rows}
                                    loading={ShowLoading}
                                    //--> روی سطر تیکت گفتگوی تیکت، و روی سطر وظیفه فرم وظیفه باز می شود
                                    onRowClick={(rowData) => OpenRow(rowData)}
                                    rowClassName={() => 'HandCursor'}
                                >
                                    <Column flexGrow={2}>
                                        <HeaderCell><b>کارشناس</b></HeaderCell>
                                        <Cell dataKey="fullName" />
                                    </Column>
                                    <Column flexGrow={1}>
                                        <HeaderCell><b>تاریخ</b></HeaderCell>
                                        <Cell>
                                            {(rowData) => (
                                                <>
                                                    <div>{rowData.date}</div>
                                                    <div style={{ fontSize: 11, color: '#8c97a3' }}>{rowData.time}</div>
                                                </>
                                            )}
                                        </Cell>
                                    </Column>
                                    {
                                        !isTaskTab ?
                                            <Column width={110}>
                                                <HeaderCell><b>شماره</b></HeaderCell>
                                                <Cell dataKey="number" />
                                            </Column>
                                            :
                                            null
                                    }
                                    <Column flexGrow={3}>
                                        <HeaderCell><b>عنوان</b></HeaderCell>
                                        <Cell>
                                            {(rowData) => (
                                                <>
                                                    <div style={{
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }} title={rowData.title}>
                                                        {rowData.title}
                                                    </div>
                                                    <div style={{
                                                        fontSize: 11,
                                                        color: '#8c97a3',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }} title={rowData.ownerTitle}>
                                                        {rowData.ownerTitle}
                                                    </div>
                                                </>
                                            )}
                                        </Cell>
                                    </Column>
                                    <Column flexGrow={2}>
                                        <HeaderCell><b>اقدام</b></HeaderCell>
                                        <Cell>
                                            {(rowData) => (
                                                <>
                                                    <div>{rowData.stateComment}</div>
                                                    {
                                                        rowData.comment ?
                                                            <div style={{ fontSize: 11, color: '#d03b3b' }}
                                                                title={rowData.comment}>
                                                                {rowData.comment}
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </>
                                            )}
                                        </Cell>
                                    </Column>
                                </Table>
                            </ResponsiveList>
                        </div>
                    </>
            }

            {/* همان پنجره جزئیات صفحه تیکت ها. onSubmit لازم است چون
                کامپوننت بعد از ارسال پیام صدایش می زند؛ اینجا گزارش را
                دوباره می گیریم تا اگر وضعیتی عوض شده باشد دیده شود. */}
            <TicketMsgProp ref={TicketRef} onSubmit={Bind} />

            {/* جزئیات وظیفه - همان فرمی که در صفحه وظایف هست، به همراه
                تاریخچه کامل وضعیت ها */}
            <rsuite.Drawer
                open={showTaskDrawer}
                onClose={() => setShowTaskDrawer(false)}
                placement={isMobile ? 'bottom' : 'right'}
                size={isMobile ? 'full' : 'sm'}
            >
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Title>جزئیات وظیفه</rsuite.Drawer.Title>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body>
                    <TaskDetail ref={TaskRef} />
                </rsuite.Drawer.Body>
            </rsuite.Drawer>

        </Shared>
    );
}

export default Activity;
